import appConfig from '../../../config/appConfig';

var config = {
  apiUrl: appConfig.apiUrl + 'activityareas/'
};

export default config;



// WEBPACK FOOTER //
// ./src/components/activityarea/config/activityreaConfig.js